var map = {
	"./preloader-acts.svg": "349f",
	"./preloader-agent.svg": "c2d7",
	"./preloader-analytic.svg": "2e3e",
	"./preloader-orders.svg": "ffe2",
	"./preloader-transport.svg": "42bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0339";